import { createSlice } from '@reduxjs/toolkit';

const CompanyDetailsDataSlice = createSlice({
    name: 'CompanyDetailsData',
    initialState: '',
    reducers: {
        setCompanyDetailsData: (state, action) => {
            return action.payload;
        },
        resetCompanyDetailsData: (state) => {
            return null;
        },
    },
});

export const { setCompanyDetailsData, resetCompanyDetailsData } = CompanyDetailsDataSlice.actions;
export default CompanyDetailsDataSlice.reducer;